import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import styles from "../../assets/css/signupv2.module.css";
import logo from "../../assets/img/signupv2/toi/logo.svg";
import BackArrow from "../../assets/img/BackArrow.svg";
import {
  getAuth,
  resendOtp,
  resetVerifyOtp,
  updateProfile,
  verifyOtp,
} from "../../redux/slices/authSlice";
// import { getRecaptcha } from "../../redux/slices/recaptchaSlice";
// import AddCard from "../../components/AddCard";
import { getUserToken } from "../../libs/user";
import CustomOtp from "../CustomOtp";
import {
  getUtmSource,
  toiSubCallbackSuccess,
  toiSubOtpVerificationFailed,
  Web_card_cross_clicked,
  Web_phone_number_verified,
  Web_Signup_completed,
} from "../../libs/events";
import AppSkeleton from "../../components/Skeletons/AppSkeleton";

function VerifyOtp() {
  const [addCard, setAddCard] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpErr, setOtpErr] = useState("");
  const [resendOtpErr, setResendOtpErr] = useState("");
  const [counter, setCounter] = useState(0);
  const [sendOTPSuccess, setSendOTPSuccess] = useState(false);

  const authToken = getUserToken();
  const message_id = useSelector(
    (state) => state.auth.userSignup?.data?.message_id
  );
  const fingerprint = useSelector((state) => state.fingerprint);
  const { loader } = useSelector((state) => state.app);
  const { toiMobileInput } = useSelector((state) => state.auth);

  const location = useLocation();
  const { utm_source, source, bankType } = location.state || {};

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    formState: { errors },
  } = useForm();

  const handleVerifyOtp = () => {
    if (isValidForm()) {
      const input = ("+1" + toiMobileInput).replace(/[- )(]/g, "");
      const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
      const { username: email } = userData || {};
      dispatch(
        verifyOtp({
          otp,
          phone: input,
          message_id,
          fingerprint,
          updateUserEmail: true,
          email,
          utm_source: "toi_js_bridge",
        })
      )
        .unwrap()
        .then(() => {
          Web_phone_number_verified({
            utm_source: getUtmSource(),
          });
          Web_Signup_completed({
            signup_source: "web",
            mobile_number: input,
            utm_source: getUtmSource(),
          });
          dispatch(getAuth());
          // setAddCard(true);
          window.tcWebBridge.sendUserState({ status: "accept" });
          toiSubCallbackSuccess();
        })
        .catch((error) => {
          toiSubOtpVerificationFailed();
          setOtpErr(error?.error?.message);
          if (error?.error?.code === 4013 || error?.error?.code === 9002) {
            console.log(error);
          }
        });
    }
  };

  const isValidForm = () => {
    if (!otp || otp.length !== 6) {
      return false;
    }
    return true;
  };

  const otpInput = (otp) => {
    setOtp(otp);
  };

  useEffect(() => {
    setCounter(60);
    return () => {
      dispatch(resetVerifyOtp());
      setOtpErr("");
      setResendOtpErr("");
    };
  }, []);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const handleResendOTP = () => {
    const input = ("+1" + toiMobileInput).replace(/[- )(]/g, "");
    setOtpErr("");
    setOtp("");
    dispatch(
      resendOtp({
        phone: input,
        message_id,
      })
    )
      .unwrap()
      .then((response) => {
        setSendOTPSuccess(true);
      })
      .catch((error) => {
        setSendOTPSuccess(false);
        setResendOtpErr(error?.error?.message);
        console.log(error);
      });
  };

  useEffect(() => {
    if (sendOTPSuccess) {
      setCounter(60);
    }
  }, [sendOTPSuccess]);

  // useEffect(() => {
  //   dispatch(getRecaptcha({ action: "signup" }));
  // }, [dispatch]);

  const handleBack = () => {
    navigate(
      `/signup/v2?utm_source=${utm_source}&source=${source}&bankType=${bankType}`,
      {
        state: { utm_source, bankType, source, phone: toiMobileInput },
      }
    );
  };

  const handleCardAddClose = (flag) => {
    setAddCard(flag);
    Web_card_cross_clicked();
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.header}>
          <img src={logo} />
        </div>

        <div className={styles.mobileContainer}>
          <div className={styles.headerItems}>
            <img
              src={BackArrow}
              alt="BackArrow"
              className={styles.backBtn}
              onClick={() => handleBack()}
            />
            <div className={styles.headerText}>Verify Phone Number</div>
          </div>

          <div className={styles.description}>
            <span className={styles.descriptionText1}>
              We sent a 6 digit code to +1
              <span className={styles.descriptionText2}>{toiMobileInput}.</span>
              <br />
              <span className={styles.descriptionText}>
                Please enter it below.
              </span>
            </span>
          </div>

          <CustomOtp
            inputClass={styles.inputStyle}
            handleVerifyOtp={handleVerifyOtp}
            otpInput={(otp) => otpInput(otp)}
            otpError={otpErr}
            resendOtpError={resendOtpErr}
          />
          {counter !== 0 ? (
            <div
              className={styles.mobileInptText}
            >{`Resend code in ${counter}s`}</div>
          ) : (
            <div className={styles.resendOTP}>
              <a onClick={handleResendOTP}> {"Send Code Again ->"}</a>
            </div>
          )}
          <div className={styles.toiPrivacyText}>
            <span className={styles.text1}>
              By clicking Continue below, you agree to
            </span>
            <a href="/consent" target="_blank" className={styles.text2}>
              {" "}
              Abound's
            </a>

            <a href="/consent" target="_blank" className={styles.text2}>
              {" "}
              Consent,
            </a>
            <a href="/terms" target="_blank" className={styles.text2}>
              {" "}
              Terms
            </a>
            <span className={styles.text1}> and </span>
            <a href="/privacy" target="_blank" className={styles.text2}>
              privacy
            </a>
          </div>

          {loader ? (
            <AppSkeleton
              height={70}
              width="100%"
              borderRadius={8}
              className="footerBoxSkeleton"
            />
          ) : (
            <div className={styles.btnContainer}>
              <button
                className={styles.btnRed}
                onClick={() => handleVerifyOtp()}
              >
                Continue
              </button>
            </div>
          )}
        </div>
      </div>

      {/* {addCard && (
        <AddCard
          open={handleCardAddClose}
          addCard={addCard}
          messagePopup={addCard}
          source="toiPlus"
        />
      )} */}
    </>
  );
}

export default VerifyOtp;
